import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import Toast from "../../utils/toast";
import createInstance from "../../api/axiosinstance";
import "../commonLogin.css";
import { Button, TextField } from "@mui/material";

const ChangePassword = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const role = window.sessionStorage.getItem("role");
  console.log("ROLE", role);
  const aiDishaApi = createInstance("DISHA");

  const handleChange = (e) => {
    setEmail(e.target.value);
    setErrors({ ...errors, email: "" }); // Clear error on type
  };

  const validate = () => {
    if(!email){
      setErrors({
        ...errors,
        email : "Please enter a valid email id"
      })
      return false;
    }
    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(validate()){
      setLoading(true);

      if(role === "Admin"){
        try {
          
          const response = await aiDishaApi.post(
            `/admin-user-Forget-Password-Email/?email=${email}`
          );
    
          if (response.status !== 200) {
            throw new Error("Email entered is incorrect or not registered");
          }
          Toast.success(response.data.message);
          navigate("/otpVerification", {
            state: {
              email,
              source: "forget-password", 
            },
          });
        } catch (error) {
          console.error("Error:", error);
          setErrors({ email: "Error sending OTP. Please try again." });
        } finally {
          setLoading(false); 
        }
      } else if(role === "Interviewer" || role === "OrgAdmin" || role === "HR"){
        try {
          
          const response = await aiDishaApi.post(
            `/org-user-Forget-Password-Email/?email=${email}`
          );
    
          if (response.status !== 200) {
            throw new Error("Email entered is incorrect or not registered");
          }
          Toast.success(response.data.message);
          navigate("/otpVerification", {
            state: {
              email,
              source: "forget-password", 
            },
          });
        } catch (error) {
          console.error("Error:", error);
          setErrors({ email: "Error sending OTP. Please try again." });
        } finally {
          setLoading(false); 
        }
      }
    }
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center gap-4">
      <h2 className="text-center gradient-text">Change Password</h2>
      <form
        onSubmit={handleSubmit}
        className="d-flex flex-column gap-4"
        style={{ width: "100%", maxWidth: "400px" }}
      >
        <p style={{ color: "#334155", fontWeight: 500, textAlign: "center", margin: 0 }}>
          Enter Your Email to send one time Password
        </p>

        <TextField
          type="email"
          name="email"
          value={email}
          placeholder="Email ID"
          autoComplete="off"
          fullWidth
          onChange={handleChange}
          required
          size="small"
          sx={{
            backgroundColor: "#ffffff", 
            borderRadius: "8px",
            "& .MuiInputBase-input": {
              color: "#111827", 
              WebkitTextFillColor: "#111827", 
              "&::placeholder": {
                color: "#6b7280", 
                opacity: 1,
              }
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              "& fieldset": {
                borderColor: "#9ca3af",
              },
              "&:hover fieldset": {
                borderColor: "rgb(37, 99, 235)",
              },
              "&.Mui-focused fieldset": {
                borderColor: "rgb(37, 99, 235)",
                borderWidth: "2px"
              },
            }
          }}
        />
        {errors.email && <div style={{color:'#dc2626', fontSize:'12px', marginTop: '-10px'}}>{errors.email}</div>}

        <Button
          type="submit"
          className="gradient-button"
          disabled={loading} 
        >
          {loading ? <Loader /> : "SEND OTP"}
        </Button>
      </form>
    </div>
  );
};

export default ChangePassword;